export const allLocationByCompany = {

    GET_AllLocationByCompanyId: "GET_AllLocationByCompanyId",
    UPDATE_LocationByCompanyId: "UPDATE_LocationByCompanyId"
}